<template lang="pug">
include /mixins

+b.group-filters-wrap
  +b.group-filter-title-wrap
    +b.filter-title
      +b.ds-caption--size_lg.--medium.--height_2xs.P.tt-space_mr--2.is-visible-xl(
      )
        span.icon-filter_n
      +b.ds-caption--size_md.--medium.--semibold.P {{ _('Фильтры') }}
    +b.tt-link.--variant_start.--size_md.--text-8.--weight_semibold.SPAN(
      @click.prevent='handleInputFilter([])'
    ) {{ _('Очистить фильтр') }}
  +e.sidebar-content
    +b.tt-accordion
      +e.question.--simple.--spaced_bottom-none.--clear-all(
      )
        //- @click='toggleActive()',
        +e.text
          +b.ds-caption--size_md.--semibold.--color_grey.SPAN  {{ _('Группа красителя') }}
      +e.description
        +b.group-filters-content
          template(v-for='val in info.groups')
            +b.tt-space_mt--4(v-if='!val.props.is_default')
              +b.d-control-input.--appearance_flexible
                +e.element.INPUT(
                  type='checkbox'
                  :value='val.props.id',
                  name='groups'
                  :key='`input_${val.props.id}`'
                  v-model='checked'
                  :input-label='val.props.title',
                  :id='`groups:${info.idkey}:${val.id}`'
                  @change='submit()'
                )
                +e.LABEL.label--medium(
                  :for='`groups:${info.idkey}:${val.id}`'
                )
                  span.fake-link(
                  ) {{ val.props.title }}
  +e.controls
    +b.tt-button.A(
      @click.prevent='close(); $modal.hide("filters-modal")'
    )
      +e.title.SPAN {{ _('Показать') }}
</template>

<script>

import GroupConfiguratorProduct from './GroupConfiguratorProduct.vue'

export default {
  name: 'GroupConfigurator',
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
    on: {
      type: Object,
      default: () => ({}),
    },
  },
  components: {
    GroupConfiguratorProduct,
  },
  data() {
    return {
      checked: this.info.checked || [],
    }
  },
  methods: {
    submit() {
      this.$emit('input', this.checked)
    },
    handleInputFilter(filter) {
      this.checked = filter
      this.submit()
    },
    close() {
      this.info.events.input(this.checked)
    },
  },
}
</script>
